import script from "./SortScalesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SortScalesModal.vue?vue&type=script&lang=ts&setup=true"

import "./SortScalesModal.vue?vue&type=style&index=0&id=fcf43ddc&lang=css"

const __exports__ = script;

export default __exports__